"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _infoMessage = require("@/api/infoMessage");
var _throttleDebounce = require("throttle-debounce");
var _permission = require("@/utils/permission");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import creatProduct from './creatProduct'
// 权限判断函数
var _default = {
  name: 'InfoMessage',
  // components: { creatProduct },
  data: function data() {
    return {
      listLoading: true,
      orList: ['is_open_withdraw'],
      bankList: ['withdraw_money_type'],
      pram: {},
      isCreate: 0,
      tableData: {
        data: [],
        total: 0
      },
      inputList: ['min_withwraw_money', 'single_max_withdraw_money', 'today_max_withdraw_number', 'today_max_withdraw_money', 'withdraw_money', 'withdraw_money'],
      miaoList: ['withdraw_interval_time'],
      tiList: ['withdraw_money_rate_type'],
      czljjeList: [],
      tables: {
        startTime: '',
        endTime: ''
      },
      tags: ''
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    setName: function setName(key) {
      return this.$t(key);
    },
    changeRadios: function changeRadios(status) {
      this.tags = status;
    },
    checkPermi: _permission.checkPermi,
    deleteItem: function deleteItem(data, index) {
      var _this = this;
      if (data.id) {
        (0, _infoMessage.deleteSystemConfig)({
          id: data.id
        }).then(function () {
          _this.$message.success(_this.$t('sccg'));
          _this.getList();
        });
      } else {
        this.czljjeList.splice(index, 1);
      }
    },
    addItem: function addItem() {
      this.czljjeList.push({
        key: "withdraw_money_rate",
        condition: "",
        value: "",
        remark: "提现金额手续费",
        timsObj: {}
      });
    },
    // 列表
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _infoMessage.getWithdrawConfig)().then(function (res) {
        // this.tableData.data = res
        var nowIndex = res.findIndex(function (item) {
          return item.key == 'withdraw_open_time';
        });
        var times = res[nowIndex].value.split('-');
        _this2.timsObj = res[nowIndex];
        _this2.tables.startTime = times[0];
        _this2.tables.endTime = times[1];
        _this2.czljjeList = res.filter(function (item) {
          return item.key == 'withdraw_money_rate';
        });
        _this2.tableData.data = res.filter(function (item) {
          return item.key != 'withdraw_money_rate' && item.key != 'withdraw_open_time';
        });
        res.forEach(function (item) {
          if (item.key == 'withdraw_money_rate_type') {
            _this2.tags = item.value;
          }
        });
        _this2.listLoading = false;
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    submitForm: function submitForm() {
      var _this3 = this;
      this.listLoading = true;
      var list = [].concat(_toConsumableArray(this.tableData.data), _toConsumableArray(this.czljjeList), [_objectSpread(_objectSpread({}, this.timsObj), {}, {
        value: [this.tables.startTime, this.tables.endTime].join('-')
      })]);
      var data = {
        config_list: list.map(function (item) {
          var id = item.id,
            remark = item.remark,
            value = item.value,
            key = item.key,
            condition = item.condition;
          return {
            id: id,
            remark: remark,
            value: value,
            key: key,
            condition: condition
          };
        })
      };
      var isCreate = sessionStorage.getItem('isCreate');
      (0, _infoMessage.saveSystemConfig)(data).then(function (res) {
        _this3.$message.success(_this3.$t('xgcg'));
        _this3.getList();
        _this3.listLoading = false;
      }).catch(function () {
        _this3.listLoading = false;
      });
    }
  }
};
exports.default = _default;